import styled, { css, keyframes } from "styled-components";
const slideInFrames = (left) => keyframes `
  from {
    left: 110%;
  }

  to {
    left: ${left};
  }
`;
const slideOutFrames = (left) => keyframes `
  from {
    left: ${left};
  }

  to {
    left: 110%;
  }
`;
const animateSlideInFrames = (left) => () => css `
    ${slideInFrames(left)}
  `;
const animateSlideOutFrames = (left) => () => css `
    ${slideOutFrames(left)}
  `;
export const StyledAlert = styled.div `
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.grey15};
  ${({ theme }) => `box-shadow: 4px 4px 16px rgba(${theme.colors.transparentBlack}, 0.26);`}
  color: ${({ theme }) => theme.colors.white};
  position: relative;
  left: 110%;
  @media ${({ theme }) => theme.device.small} {
    padding: 0 0 1.5rem 1.5rem;
  }
  @media ${({ theme }) => theme.device.medium} {
    width: 24.75rem;
  }
  ${({ fade }) => fade
    ? css `
          animation: ${animateSlideOutFrames("0%")} 0.15s ease-in both;

          @media ${({ theme }) => theme.device.medium} {
            animation: ${animateSlideOutFrames(`calc(100% - 396px)`)} 0.15s
              ease-in both;
          }
        `
    : css `
          animation: ${animateSlideInFrames("0%")} 0.3s ease-in both;

          @media ${({ theme }) => theme.device.medium} {
            animation: ${animateSlideInFrames(`calc(100% - 396px)`)} 0.3s
              ease-in both;
          }
        `}

  > div:first-child {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    font-size: ${({ theme }) => theme.fontTokens.font10[0]};
    line-height: ${({ theme }) => theme.fontTokens.font10[1]};
    font-weight: ${({ theme }) => theme.fontWeights.medium};

    @media ${({ theme }) => theme.device.medium} {
      font-size: ${({ theme }) => theme.fontTokens.font09[0]};
      line-height: ${({ theme }) => theme.fontTokens.font09[1]};
    }
  }

  > div:first-child div {
    padding-top: 1.5rem;
    padding-bottom: 0.5rem;
    min-height: 2.5rem;
    word-break: break-word;
  }

  > div:first-child button {
    width: 2.75rem;
    height: 2.75rem;

    margin: 1rem 1rem 0 0.5rem;
    > span {
      min-width: 2.75rem;
      height: 2.75rem;
    }

    @media ${({ theme }) => theme.device.medium} {
      width: 2.5rem;
      height: 2.5rem;
      > span {
        min-width: 2.5rem;
        height: 2.5rem;
      }
    }
  }

  span {
    svg {
      fill: ${({ theme }) => theme.colors.white};
      width: 1.25rem;
    }
  }
`;
export const StyledAlertContent = styled.div `
  padding-right: 1.5rem;
  div:nth-child(1) {
    padding-bottom: 1.5rem;
    font-size: ${({ theme }) => theme.fontTokens.font12[0]};
    line-height: ${({ theme }) => theme.fontTokens.font12[1]};
    font-weight: ${({ theme }) => theme.fontWeights.regular};
  }

  div:nth-child(2) {
    display: flex;
    justify-content: flex-end;
  }
`;
export const ButtonsContainer = styled.div `
  button:first-of-type {
    margin-right: 1rem;
  }
`;
